import { render, staticRenderFns } from "./customerOwnerCurrentAccount.vue?vue&type=template&id=0604267c&scoped=true"
import script from "./customerOwnerCurrentAccount.vue?vue&type=script&lang=js"
export * from "./customerOwnerCurrentAccount.vue?vue&type=script&lang=js"
import style0 from "./customerOwnerCurrentAccount.vue?vue&type=style&index=0&id=0604267c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604267c",
  null
  
)

export default component.exports